import { Select } from "antd";
import React from "react";
import { IMobilyticsBenchmarkItem } from "../../../Models/IMobilyticsBenchmarkItem";
import { formatLabelWithEllipsis, PolygonNameWithCircle } from "../../Common";

interface IMobilyticsPolygonSelectProps {
  benchmarkItems: IMobilyticsBenchmarkItem[];
  selectedIndex: number;
  onChange: (value: string) => void;
}

const MobilyticsPolygonSelect = (props: IMobilyticsPolygonSelectProps) => {
    const selectedPolygon = props.benchmarkItems[props.selectedIndex];

    return (
        <PolygonNameWithCircle
            circleColor={props.selectedIndex === 0 ? "lightGreen" : "darkGreen"}
            circleWidth={15}
            circleHeight={15}
            children={
                <Select
                    className="has-circle"
                    defaultValue={props.benchmarkItems[0].name}
                    value={formatLabelWithEllipsis(selectedPolygon.name, 12)}
                    onChange={props.onChange}
                >
                    {props.benchmarkItems.map((polygon, index) => {
                        return (
                            <Select.Option value={index} key={polygon.jobId}>
                                <PolygonNameWithCircle
                                    circleColor={index === 0 ? "lightGreen" : "darkGreen"}
                                    circleWidth={15}
                                    circleHeight={15}
                                >
                                    {formatLabelWithEllipsis(polygon.name, 12)}
                                </PolygonNameWithCircle>
                            </Select.Option>
                        );
                    })}
                </Select>
            }
            isSelect={true}
        />
    );
};

export default MobilyticsPolygonSelect;
